import { render, staticRenderFns } from "./index.vue?vue&type=template&id=712341fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=712341fc&prod&lang=stylus&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=712341fc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712341fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopBar: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/TopBar/index.vue').default,VideoPlayer: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/VideoPlayer/index.vue').default,NoNetwork: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/NoNetwork/index.vue').default})
